import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import PickerInput from "./PickerInput";
import { ShortCut } from "./enum";
import PopperContainer from "./PopperContainer";
import { DateRangePickerProps, IDateRangeValue, IDateValue } from "./interface";
import { CalendarContainerProps } from "react-datepicker/dist/calendar_container";

const DateRangePicker: React.FC<DateRangePickerProps> = ({
  value,
  onSubmit,
}) => {
  const datePickerRef = useRef<DatePicker>(null);

  const [selectedDates, setSelectedDates] = useState<IDateRangeValue>();

  const [confirmedDates, setConfirmedDates] = useState<IDateRangeValue>();

  useEffect(() => {
    setSelectedDates(value);
    setConfirmedDates(value);
  }, [value, setSelectedDates, setConfirmedDates]);

  const handleDateChange = (dates: IDateRangeValue) => {
    setSelectedDates(dates);
  };

  const setCustomRange = (range: ShortCut) => {
    const today = new Date();
    let start: IDateValue = null,
      end: IDateValue = null;

    switch (range) {
      case ShortCut.TODAY:
        start = today;
        end = today;
        break;
      case ShortCut.YESTERDAY:
        start = moment(today).subtract(1, "d").toDate();
        end = moment(today).subtract(1, "d").toDate();
        break;
      case ShortCut.THIS_WEEK:
        start = moment().startOf("week").toDate();
        end = moment().endOf("week").toDate();
        break;
      case ShortCut.THIS_MONTH:
        start = moment().startOf("month").toDate();
        end = moment().endOf("month").toDate();
        break;
      case ShortCut.THIS_YEAR:
        start = moment().startOf("year").toDate();
        end = moment().endOf("year").toDate();
        break;
      default:
        break;
    }

    setSelectedDates([start, end]);
    setConfirmedDates([start, end]);
    onSubmit([start, end]);
    datePickerRef.current?.setOpen(false);
  };

  return (
    <DatePicker
      ref={datePickerRef}
      onChange={handleDateChange}
      dateFormat="d MMM Y"
      startDate={selectedDates ? selectedDates[0] : null}
      endDate={selectedDates ? selectedDates[1] : null}
      selectsRange
      autoFocus
      shouldCloseOnSelect={false}
      popperPlacement="bottom-start"
      monthsShown={2}
      maxDate={new Date()}
      calendarContainer={({ children, ...props }: CalendarContainerProps) => (
        <PopperContainer
          selectedDates={selectedDates}
          onCancel={() => {
            datePickerRef.current?.setOpen(false);
          }}
          onConfirm={() => {
            setConfirmedDates(selectedDates);
            onSubmit(selectedDates);
            datePickerRef.current?.setOpen(false);
          }}
          onOptionClick={setCustomRange}
          {...props}
        >
          {children}
        </PopperContainer>
      )}
      customInput={<PickerInput confirmedDates={confirmedDates} />}
    />
  );
};

export default DateRangePicker;
